const helloAndGoodbye = {
  roleplayId: "nualang.hello-goodbye.0.0.1",
  roleplayName: "Ciao e arrivederci",
  description: "Impara a salutare e arrivederci",
  difficulty: "ALL",
  learnLang: "italian",
  picture: "",
  actor1: {
    name: "Diego",
    voice: "Diego",
    picture:
      "https://images.nualang.com/eyJidWNrZXQiOiJudWFsYW5nLWltYWdlcy1wcm9kIiwia2V5IjoiYXZhdGFycy8wLW51YWxhLTAwNC5wbmcifQ==",
  },
  actor2: {
    name: "Bianca",
    voice: "Bianca",
    picture:
      "https://images.nualang.com/eyJidWNrZXQiOiJudWFsYW5nLWltYWdlcy1wcm9kIiwia2V5IjoiYXZhdGFycy8wLW51YWxhLTAwMi5wbmcifQ==",
  },
  script: [
    { text: "Ciao. Come stai?", actor: 1 },
    { text: "Sto bene. Grazie per avermelo chiesto. Come stai?", actor: 2 },
    { text: "Non mi posso lamentare, la mia vita sta andando bene.", actor: 1 },
    { text: "È bello sentirlo.", actor: 2 },
    {
      text: "È stato un piacere rivederti. Ora devo andare, ho all'appuntamento dal dottore.",
      actor: 1,
    },
    { text: "È stato molto bello vederti! Arrivederci", actor: 2 },
    { text: "Arrivederci.", actor: 1 },
  ],
};

export default helloAndGoodbye;
